





















import { PropType } from 'vue';
import { FullEventModel } from '../../../../shared/models/fullEvent.model';
import AttachmentList from '../../../../shared/components/AttachmentList.vue';
import MediaThumbnail from '../../../../shared/components/MediaThumbnail.vue';
import MediaDetail from '../../gallery/MediaDetail.vue';
import { MediaModel } from '../../../../shared/models/media.model';
import { mediaUtil } from '../../../../shared/utils/mediaUtil';
import { useUserProfileStore } from '../../../../shared/stores';

const NUMBER_OF_THUMBNAILS = 4;
export default {
  components: { MediaDetail, MediaThumbnail, AttachmentList },
  props: {
    eventData: { type: Object as PropType<FullEventModel>, required: true },
  },
  emits: ['open'],
  data() {
    return {
      isVisibleMediaGallery: false,
      selectedMediaId: null,
    };
  },
  computed: {
    userProfile() {
      return useUserProfileStore()?.institutionProfile;
    },
    mediaList() {
      return mediaUtil
        .filterScannedMediaForProfile(this.eventData.attachments, this.userProfile.profileId)
        .map(attachment => attachment.media);
    },
    hasMoreMedia() {
      return this.mediaList.length > NUMBER_OF_THUMBNAILS;
    },
    numberOfHiddenMedia() {
      if (!this.hasMoreMedia) {
        return 0;
      }
      return this.mediaList.length - NUMBER_OF_THUMBNAILS;
    },
    visibleThumbnailMedia() {
      return this.mediaList.slice(0, NUMBER_OF_THUMBNAILS);
    },
    gridLayoutClass() {
      switch (this.visibleThumbnailMedia.length) {
        case 1:
          return 'grid-layout-1';
        case 2:
          return 'grid-layout-2';
        case 3:
          return 'grid-layout-3';
        default:
          return 'grid-layout-4';
      }
    },
  },
  methods: {
    getOverlayText(mediaIndex) {
      if (mediaIndex < NUMBER_OF_THUMBNAILS - 1 || !this.hasMoreMedia) {
        return '';
      }
      return `+${this.numberOfHiddenMedia}`;
    },
    openMediaGallery(media: MediaModel) {
      this.isVisibleMediaGallery = true;
      this.selectedMediaId = media.id;
    },
    closeMediaGallery() {
      this.isVisibleMediaGallery = false;
      this.selectedMediaId = null;
    },
    emitOpen(data) {
      this.$emit('open', data);
    },
  },
};
